import React, { useState } from "react";
import styled, { css } from "styled-components";
import { useNavigate } from "react-router-dom";
import * as Icons from "react-icons/io5";
import { Me } from "../types/Me";
import { formatJapaneseDate } from "../utils/time";

type MeInfoProps = {
  user: Me;
};

const MeInfo: React.FC<MeInfoProps> = ({ user }) => {
  const navigate = useNavigate(); // ← 追加

  const [isDetailsVisible, setIsDetailsVisible] = useState(false);

  const toggleDetails = () => {
    setIsDetailsVisible(!isDetailsVisible);
  };

  const truncateBio = (bio: string) => {
    const lines = bio.split("\n");
    if (lines.length > 5 || bio.length > 100) {
      return bio.substring(0, 100) + "...";
    }
    return bio;
  };

  return (
    <MeInfoContainer>
      <MeInfoDiv onClick={toggleDetails}>
        <MeInfoLeft>
          <UserIcon src={user.icon_url} alt="user icon" />
          <DisplayName>{user.display_name || user.scratch_name}</DisplayName>
        </MeInfoLeft>
        {isDetailsVisible
          ? Icons.IoChevronUp({ className: "meInfo-details-icon" })
          : Icons.IoChevronDown({ className: "meInfo-details-icon" })}
      </MeInfoDiv>
      <MeDetails isVisible={isDetailsVisible}>
        <p className="scratchInfo">
          @{user.scratch_name} #{user.scratch_id}
        </p>
        <p>参加日: {formatJapaneseDate(user.joined_at)}</p>
        <Bio>{truncateBio(user.bio)}</Bio>
        <FollowInfo>
          <span onClick={() => navigate(`/${user.scratch_name}/following`)}>
            {user.following_count} フォロー
          </span>
          <span onClick={() => navigate(`/${user.scratch_name}/followers`)}>
            {user.follower_count} フォロワー
          </span>
        </FollowInfo>
      </MeDetails>
    </MeInfoContainer>
  );
};

const MeInfoContainer = styled.div`
  background: rgb(251, 251, 251);
  border-radius: 16px 16px 0 0;
  padding: 16px 16px 0 0;
`;

const MeInfoDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 24px 12px 16px;
  cursor: pointer;
  flex-wrap: wrap;
`;

const MeInfoLeft = styled.div`
  display: flex;
  align-items: center;
`;

const UserIcon = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-right: 16px;
  object-fit: cover;
`;

const DisplayName = styled.span`
  font-weight: bold;
`;

const MeDetails = styled.div<{ isVisible: boolean }>`
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  max-height: 0;
  opacity: 0;
  padding: 0 16px;
  margin-top: 0;
  border-top: 1px solid transparent;
  transition: max-height 0.35s ease-in-out, opacity 0.35s ease-in-out,
    padding 0.35s ease-in-out, margin-top 0.35s ease-in-out,
    border-color 0.35s ease-in-out;

  ${({ isVisible }) =>
    isVisible &&
    css`
      max-height: 500px;
      opacity: 1;
      padding: 16px;
      margin-top: 12px;
      border-top: 1px solid #e0e0e0;
    `}
`;

const Bio = styled.p`
  margin: 8px 0;
  white-space: pre-wrap;
`;

const FollowInfo = styled.div`
  display: flex;
  gap: 16px;
  color: rgb(0, 0, 0);

  span {
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export default MeInfo;
